import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import { Typography, Button } from '@mui/material';
import { VBox } from '../../assets/SharedComponents';
import useAuth0Feathers from '../../hooks/useAuth0Feathers';
import { useState } from 'react';
import { CustomBusy } from 'Components/Common/CustomBusy.jsx';
import { Animated } from "react-animated-css";
import microsoftpng from '../../assets/microsoftPng.png';
import employeeSvg from '../../assets/employeeSvg.svg';

const useStyles = makeStyles(() => ({
    loginTitle: {
        fontSize: "1.25rem !important",
        fontWeight: "700 !important"
    },
    officeBox: {
        height: '100% !important',
        alignContent: 'center !important',
        alignItems: 'center !important',
        margin: '1rem !important'
    },
    buttonGreen: {
        color: 'white !important',
        fontSize: '1.2rem !important',
        fontWeight: 'bold !important',
        backgroundColor: '#3a7735 !important',
        borderRadius: '2rem !important',
        boxShadow: '0 8px 9px rgb(125 125 125 / 40%)',
        textTransform: "capitalize !important"
    },
}));

export const Office365TabAuth0 = ({ handleChange, setTribeUserTab }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [busy, setBusy] = useState(false);
    const { loginWithOffice365, loading, error } = useAuth0Feathers();

    const handleMicrosoftLogin = async () => {
        setBusy(true);
        try {
            await loginWithOffice365();
            // Navigation happens automatically in the hook after successful auth
        } catch (error) {
            console.error('Microsoft login failed:', error);
            setBusy(false);
        }
    };

    return (
        <Animated animationOut="fadeInDown" animationOutDuration={3500} isVisible={true}>
            <VBox className={classes.officeBox}>
                <Typography align='center' className={classes.loginTitle}>
                    {t("empLogin")}
                </Typography>

                {(loading || busy) && <CustomBusy text={t("loginBusy")} />}
                {error && <Typography align='center' color="error">{error.message}</Typography>}

                <img
                    alt="Employee"
                    width="200px"
                    height="200px"
                    src={employeeSvg}
                />
                <img
                    alt="Microsoft"
                    width="45px"
                    height="34px"
                    src={microsoftpng}
                />
                <Typography align='center'>{t("microsoftText")}</Typography>

                {(busy || loading) ? (
                    <CustomBusy text={t("loginBusy")} />
                ) : (
                    <Button
                        className={classes.buttonGreen}
                        onClick={handleMicrosoftLogin}
                        sx={{ marginTop: "2.5rem" }}
                    >
                        {t("moveToLogin")}
                    </Button>
                )}
            </VBox>
        </Animated>
    );
};